/*
--------------------------------------------------------------------------------
Pregress Meter Bar
--------------------------------------------------------------------------------
*/

import "../Styles/progress-meter-ui.css";

(function($) {

    'use strict';

    if (typeof ori !== "object") return;

    var self = null,
        $initialContext = null,
        $context,
        PROGRESS_METER_CLASS = "js-progress-meter",
        PROGRESS_METER = "." + PROGRESS_METER_CLASS,
        NOT_SUBSTEP_ITEM = ":not(.substep-item)",
        PROGRESS_METER_ITEM = ".js-progress-meter-item",
        CURRENT = ".current",
        PASSED_STEPS_CONTAINER = ".passed",
        FUTURE_STEPS_CONTAINER = ".future",
        SIZE_3_INDEX = 2,

        SHOPPING_BAG_CONTENT = ".w-content-shopping-bag",
        STICKY_PROGRESS_METER = ".js-stick-progress-meter",
        STICKY_BAR = ".js-sticky-bar",
        STICKY_BAR_TOP_NAV_3 = "online-top-area-root",
        maxWidth = "max-width";

    function isTopNav3() {
        return Boolean(document.getElementById(STICKY_BAR_TOP_NAV_3));
    }

    ori.addModule("progressMeter", {
        wrapSteps: function(progressMeterData) {

            if (typeof progressMeterData === "string") {
                $context = $(progressMeterData);
            }  else if (typeof progressMeterData === "number") {
                $context = $("[data-navigation-id='" + progressMeterData + "']").parents(PROGRESS_METER);
            } else if (progressMeterData instanceof jQuery && progressMeterData.hasClass(PROGRESS_METER_CLASS)) {
                $context = progressMeterData;
            } else {
                return;
            }

            var isPassedWrapperApplied = $context.find(PASSED_STEPS_CONTAINER).length > 0;
            if (isPassedWrapperApplied) {
                $context.find(PASSED_STEPS_CONTAINER + " " + PROGRESS_METER_ITEM + NOT_SUBSTEP_ITEM).unwrap();
            }

            var isFutureWrapperApplied = $context.find(FUTURE_STEPS_CONTAINER).length > 0;
            if (isFutureWrapperApplied) {
                $context.find(FUTURE_STEPS_CONTAINER + " " + PROGRESS_METER_ITEM + NOT_SUBSTEP_ITEM).unwrap();
            }

            var $currentStep = $context.find(CURRENT + NOT_SUBSTEP_ITEM);
            // gradient should be applied for passed steps + current step
            var passedSteps = $currentStep.prevAll().addBack(),
            // find future steps
                futureSteps = $currentStep.nextAll();

            // wrap passed+current steps
            passedSteps.wrapAll("<span class='passed'></span>");

            // wrap future steps
            futureSteps.wrapAll("<span class='future'></span>");

            updateSteps();
        },

        initStickyProgressMeter: function () {
            // top position is driven by CSS for Top Nav 3.0
            if (isTopNav3()) {
                return;
            }
            if (isMobileBreakpoint()) {
                scrollProgressMeterMobile();
            } else {
                scrollProgressMeterDesktop();
            }
        },

        getProgressMeterTopOffset: function() {
            var progressMeter = document.querySelector(PROGRESS_METER);
            if (progressMeter) {
                return progressMeter.getBoundingClientRect().top;
            } else {
                return 0;
            }
        },

        getProgressMeterHeight: function() {
            var progressMeter = document.querySelector(PROGRESS_METER);
            if (progressMeter) {
                return progressMeter.offsetHeight;
            } else {
                return 0;
            }
        }
    });

    $initialContext = $(PROGRESS_METER);
    registerEventHandlers();

    /* anonymous fuction is used for recalculating width of each step
    ** after screen resize without DOM manipulating */
    function updateSteps() {
        var isMobileWidth = isMobileBreakpoint();
        isMobileWidth ? setMobileStepWidth($context) : setStepWidth($context);
    }

    function isMobileBreakpoint() {
        var isMobile = ori.device.activeBreakpoint.index <= SIZE_3_INDEX;
        return isMobile;
    }

    function registerEventHandlers() {
        ori.device.bindMedia(updateSteps);

        /* so far sticky functionality is limited
        ** only for shopping bag page */
        var isShoppingBagPage = $(document).find(SHOPPING_BAG_CONTENT).length || false;
        if (isShoppingBagPage) {
            ori.device.bindReady(function() {
                self.initStickyProgressMeter();
                ori.device.bindMedia(self.initStickyProgressMeter);
            });
        }
    }

    function setMobileStepWidth($context) {
        var progressMeterWidth = $context.outerWidth(),
            stepsNumber = $context.find(PASSED_STEPS_CONTAINER).children(":visible:not(" + CURRENT + ")").length + $context.find(FUTURE_STEPS_CONTAINER).children(":visible:not(" + CURRENT + ")").length;
        $context.find(CURRENT).width(progressMeterWidth * 0.3).css(maxWidth, progressMeterWidth * 0.3 + "px"); /* 0.3 = 30% width for current step; max width limit for text ellipsis */
        var notCurrentStepWidth = progressMeterWidth * 0.7 / stepsNumber; /* 0.7 = 70% width for all not current steps */
        $context.find(PROGRESS_METER_ITEM + ":not(" + CURRENT + ")").width(notCurrentStepWidth);
    }

    function setStepWidth($context) {
        var progressMeterWidth = $context.outerWidth(),
            stepsNumber = $context.find(PASSED_STEPS_CONTAINER).children(":visible" + NOT_SUBSTEP_ITEM).length + $context.find(FUTURE_STEPS_CONTAINER).children(":visible" + NOT_SUBSTEP_ITEM).length,
            eachStepWidth = (progressMeterWidth / stepsNumber).toFixed(2);
        $context.find(PROGRESS_METER_ITEM).width(eachStepWidth).css(maxWidth, eachStepWidth + "px"); /* max width limit for text ellipsis */
    }

    function scrollProgressMeterMobile() {
        if ($(STICKY_BAR).length) {
            var newOffsetTop = $(STICKY_BAR).outerHeight();
        } else {
            var newOffsetTop = 0;
        }

        $(STICKY_PROGRESS_METER).css({
            top: newOffsetTop
        });
    }

    function scrollProgressMeterDesktop() {
        $(STICKY_PROGRESS_METER).css("top", "");
    }


    self = ori.progressMeter;

    if ($initialContext.length) {
        // initialization for design library
        $initialContext.each(function(index, value) {
            var $progressMeter = $(value);

            ori.device.bindReady(function() {
                self.wrapSteps($progressMeter);
            });
        });
    }

})(jQuery);